<template>
  <div class="collectionDetailGallery"
    :style="pageSetting">
    <button type="button" class="btnClose" @click.stop="close"></button>
    <div class="frame">
      <div v-if="subItem.imageList.length > 0" class="imageList">
        <swiper
          :options="swiperOptions"
          ref="imageList"
          class="imageWrapper">
          <swiper-slide v-for="(img, index) in subItem.imageList" :key="index">
            <div class="img"><img :src="img" alt=""></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div v-if="imgIndicator" class="imgIndicator">
          <span
            v-for="img in imgIndicator.length"
            :key="img"
            class="dot"
            :style="{backgroundColor: imgIndicator.color}"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'DetailSubItemGallery',
  props: [
    'locale',
    'lang',
    'pageId',
  ],
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    subItem () {
      return this.$store.getters['collection/getDetailSubItemGallery']
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    collectionSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    pageSetting () {
      const setting = this.collectionSetting
      const itemDetail = this.itemInfo && this.itemInfo.attribute
      return  {
        backgroundColor: setting.backgroundColor,
        color: itemDetail && itemDetail.detailColorActive ? itemDetail.detailTextColor : ''
      }
    },
    itemInfo () {
      const collectionItemId = this.collectionItemId
      return collectionItemId && this.$store.getters['collection/getItemByItemId'](collectionItemId)
    },
    imgIndicator () {
      return this.subItem.imageList && this.subItem.imageList.length > 1 ? {
        length: this.subItem.imageList.length,
        color: this.getPointColor
      } : null
    },
  },
  mounted () {
    this.$nextTick(() => {
      const swiper = this.$refs.imageList.swiper
      if (swiper) {
        swiper.slideTo(0)
      }
    })
  },
  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplay: false,
        threshold: 80,
        slidesPerView: 1
      }
    }
  },
  methods: {
    close () {
      this.$store.commit('collection/setDetailSubItemGallery', null)
    }
  }
}
</script>
